<div class="table-footer">
  <div class="table-actions h3-bold horizontal-scroll">
    @if (pageInfo && pageInfo.isShowSelected && pageInfo!.selectedRows! > 0) {
      <div class="row-count">
        Selected <span class="count">{{ pageInfo.selectedRows }}</span> of
        <span class="total-selected">{{ pageInfo.totalRows }}</span>
      </div>
      <div class="vertical-line"></div>
    }
    @if (pageInfo && pageInfo.selectedRows === 0) {
      <div class="row-count">
        Showing <span class="count">{{ pageInfo.showingRowsCount }}</span> of
        <span class="total-selected">{{ pageInfo.totalRows }}</span>
      </div>
      <div class="vertical-line"></div>
    }
    <ng-content></ng-content>

    @if (pageInfo.isHeaderSelectAll) {
      <app-link-btn
        [label]="(pageInfo.isSelectAllData ? 'Selected all ' : 'Select all ') + pageInfo.totalRows"
        [active]="false"
        size="large"
        [IconType]="''"
        [disabled]="false"
        (custom_click)="
          pageInfo.isSelectAllData = !pageInfo.isSelectAllData;
          custom_click.emit({
            action: 'select_all',
            value: pageInfo.isSelectAllData,
          })
        "></app-link-btn>
    }
    @if ((pageInfo.selectedRows || 0) > 0) {
      @for (link of footerLinks; track link) {
        <div class="footer-link">
          <app-link-btn
            label="{{ link.label }}"
            [active]="link.active"
            size="large"
            [alert]="link.alert"
            IconType="{{ link.IconType }}"
            [disabled]="link.disabled"
            (custom_click)="custom_click.emit({ action: link.label, value: link })"
            [cdkMenuTriggerFor]="showDropdown(link) ? menu : null"
            cdkConnectedOverlayOrigin></app-link-btn>
          <ng-template #menu>
            <div class="bottom-margin" cdkMenu>
              <div class="custom-dropdown radius-4 radius-bottom-left">
                @if (link.dropdown && link.dropdown.length > 0) {
                  @for (dropdownItem of link.dropdown; track dropdownItem) {
                    <dropdown-single-piece
                      class="w-100 cursor-pointer"
                      (keydown)="navigateOnKeydown($event)"
                      (onAction)="
                        onActions.emit({
                          event: dropdownItem.label,
                          value: dropdownItem,
                        })
                      "
                      [label]="dropdownItem.label"
                      [color]="dropdownItem.color"
                      [type]="'bold'"
                      [icon]="true"
                      [iconType]="dropdownItem.icon"
                      [dragDrop]="false"
                      [toggle]="false"
                      [more]="false"
                      [radio]="false"
                      cdkMenuItem></dropdown-single-piece>
                  }
                }
              </div>
            </div>
          </ng-template>
        </div>
      }
    }
  </div>
  @if (pageInfo.isShowPagination) {
    <app-pagination
      [state]="'default'"
      [current]="pageInfo.currentPage"
      [total]="pageInfo.totalPages"
      (onPageChange)="pageChange($event)"></app-pagination>
  }
</div>
